import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Schoolviewtile } from '../models/schoolviewtile.model';
import { Schooladminitem } from '../models/school/schooladminitem.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SchoolmanagementService {

  private getSchoolFromSubdomainPromise: Promise<any>;

  uploadSchoolLogo(id: any, file: File) {
    let formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(
      this.rootURL + `school/updateschoollogo?schoolid=${id}`,
      formData
    );
  }

  readonly rootURL = environment.ImpataAppAPIRoot;
  readonly UserOnlyViewType = 'ONLY_USER_ITEMS';
  readonly AllSchoolViewType = 'ALL_SCHOOL_ITEMS';
  readonly ADD_USER = 'ADD';
  readonly REMOVE_USER = 'REMOVE';
  readonly ENABLE_USER = 'ENABLE';
  readonly DISABLE_USER = 'DISABLE';

  constructor(private router: Router, private http: HttpClient) { }
  editSchool(data: any) {
    return this.http.post(this.rootURL + 'school/edit', data);
  }

  createSchool(data: any) {
    var req_headers = new HttpHeaders({
      'content-type': 'application/json',
      accept: 'application/json',
    });
    return this.http.post(this.rootURL + 'school/create', data, {
      headers: req_headers,
    });
  }

  getUserSchools() {
    var req_headers = new HttpHeaders({
      'content-type': 'application/json',
      accept: 'application/json',
    });
    return this.http.get(
      this.rootURL + `school/viewschools?viewtype=${this.UserOnlyViewType}`
    );
  }

  getSchoolUsers(schoolID: number) {
    return this.http.get(
      this.rootURL + `school/schooladmins?schoolID=${schoolID}`
    );
  }

  // getSchoolInfo(schoolID: number) {
  //   return this.http.get(
  //     this.rootURL + `school/getschoolinfo?schoolID=${schoolID}`
  //   );
  // }

  async getSchoolFromSubdomain() {
    //debugger;
    if(!this.getSchoolFromSubdomainPromise){
      this.getSchoolFromSubdomainPromise = this.http.get<any>(this.rootURL + `school/getschoolinfofromsubdomain`).toPromise().catch(() => {
        this.getSchoolFromSubdomainPromise = null;
      });
    }
    return await this.getSchoolFromSubdomainPromise;
  }

  getSchoolIdFromSubdomain() {
    return this.http.get<number>(`${this.rootURL}school/getschoolidfromsubdomain`)
  }

  getSchoolDetails(schoolID: number = 0) {
    return this.http.get(
      this.rootURL + `school/getSchoolDetails?schoolID=${schoolID}`
    );
  }

  manageUser(_schoolID: number, targetEmail: string, actionType: string) {
    let data = {
      schoolID: _schoolID,
      targetEmail: targetEmail,
      userAction: actionType,
    };
    return this.http.post(
      this.rootURL + `school/manageschooladmin?userAction=${actionType}`,
      data
    );
  }

  getStudentsfromschoolid(
    schoolID: number,
    page: number,
    itemsPerPage: number
  ) {
    //debugger;
    return this.http.get(
      this.rootURL +
      `school/getSchoolStudentsList?schoolID=${schoolID}&page=${page}&itemsPerPage=${itemsPerPage}`
    );
  }

  uploadenrolfile(schoolid: any, file: any) {
    let formData = new FormData();
    formData.append('file', file[0], file[0].name);
    return this.http.post(
      this.rootURL + `school/batchenrollstudents?schoolid=${schoolid}`,
      formData
    );
  }

  downloadSchoolStudent(schoolid: number): Observable<any> {
    return this.http.get(
      this.rootURL + `school/downloadschoolstudent?schoolid=${schoolid}`,
      { responseType: 'blob' }
    );
  }

  changeTutorSendMail(schoolid) {
    var req_headers = new HttpHeaders({
      'content-type': 'application/json',
      accept: 'application/json',
    });
    return this.http.post(this.rootURL + 'school/updatesendmail', schoolid, {
      headers: req_headers,
    });
  }

  sendTestMail(mailData) {
    var req_headers = new HttpHeaders({
      'content-type': 'application/json',
      accept: 'application/json',
    });
    return this.http.post(this.rootURL + 'school/sendtestmail', mailData, {
      headers: req_headers,
    });
  }

  sendMail(mailData) {
    var req_headers = new HttpHeaders({
      'content-type': 'application/json',
      accept: 'application/json',
    });
    return this.http.post(this.rootURL + 'school/sendmail', mailData, {
      headers: req_headers,
    });
  }

  saveMailDraft(mailData) {
    var req_headers = new HttpHeaders({
      'content-type': 'application/json',
      accept: 'application/json',
    });
    return this.http.post(this.rootURL + 'school/savedraft', mailData, {
      headers: req_headers,
    });
  }

  deleteMailDraft(id: number){
    return this.http.delete(this.rootURL + `school/deletedraft?id=${id}`);
  }
  
  getMailDraft() {
    var req_headers = new HttpHeaders({
      'content-type': 'application/json',
      accept: 'application/json',
    });
    return this.http.get(this.rootURL + 'school/maildraft', {
      headers: req_headers,
    });
  }
  uploadSchoolAppLogo(id: any, file: File) {
    let formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(
      this.rootURL + `school/updateschoolapplogo?schoolid=${id}`,
      formData
    );
  }
}
